export default __webpack_public_path__ + "static/media/cancel_run.2dddd3b9.svg";